export const endpoints = {
  subscriberGroupItem: 'subscriberGroup',
  languageOptions: 'subscriberGroup/language/options'
};
